import React from "react";

const SmallSpnner = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <div className="w-20 h-20 border-2 border-dashed rounded-full animate-spin  border-blue-500">
      </div>
      <p>loading....</p>
    </div>
  );
};

export default SmallSpnner;
